import tw from 'twin.macro';

export const Wrapper = tw.div`mb-8 md:mb-16`;
